import Subgroup from '../Subgroup';
import Collapse from '../Collapse';

export default {
  name: 'Group',
  components: {
    Subgroup,
    Collapse,
  },
  props: {
    documentSlug: {
      type: String,
      default: '',
    },
    groups: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    section: '',
    groupOpenedIndex: [],
    isVisible: false,
  }),
};
